<pdf-viewer *ngIf="hasFile && !filename" [src]="selectedUrl ? selectedUrl : pdf ? pdf.Url : pdfUrl!" [original-size]="false"
            [style]="'width:' + previewSize +'; height:' + previewSize + '; flex-shrink: 0'"></pdf-viewer>
<div *ngIf="filename" class="pdf-filename">{{filename}}</div>

<div class="upload-area">
    <p-fileUpload accept=".pdf" [showCancelButton]="false" [showUploadButton]="false" [customUpload]="true" (onSelect)="onFilesSelected($event)" [disabled]="disabled"
                  [chooseLabel]="hasFile ? 'Replace with File' : 'Select File'">
        <ng-template pTemplate="toolbar">
            <div class="select-buttons">
                <button *ngIf="organization.IsDocumentCenterEnabled" pButton type="button" class="" [label]="hasFile ? 'Replace with Document' : 'Select Document'" icon="pi pi-plus"
                        [disabled]="disabled" (click)="onChooseExistingPDF()"></button>
                <button *ngIf="hasFile" pButton type="button" class="p-button-warning" label="Remove" icon="pi pi-trash" [disabled]="disabled" (click)="onRemovePdf()"></button>
            </div>
        </ng-template>
    </p-fileUpload>
</div>

<mycampapp-select-document-pdf *ngIf="selectExistingPdfVisible" (pdfSelected)="onPdfSelected($event)"></mycampapp-select-document-pdf>
